/**
* Parallax element
**/

; (function ($, window) { // eslint-disable-line no-extra-semi
    'use strict';

    /**
     * Focus component constructor
     * @param $element
     * @param target
     */
    var Parallax = function ($element, options) {
        this._$el = $element;
        this._options = $.extend(false, Parallax.config, options);

        this._init();
    };

    /*
     * Default settings
     */
    Parallax.config = {
        classes: {
            set: 'set--parallax',
            parent: 'set--img-parallax'
        },
        speed: -2,
        percentage: .5,
        parent: 'body',
    };

    Parallax.prototype._init = function () {
        var self = this;

        this._$el
            .addClass(this._options.classes.set)
            .parent()
            .addClass(this._options.classes.parent);

        self._update();

        $(window).bind('scroll', function () {
            this._update();
        }.bind(this))
    }

    Parallax.prototype._update = function () {
        var self = this,
            rect = $(self._options.parent)[0].getBoundingClientRect(),
            mid = rect.y + rect.height * self._options.percentage,
            offset = ((mid / $(self._options.parent).outerHeight()) - .5) * self._options.speed * -100,
            roundOffset = Math.round(offset),
            position = 'translate3d(0,' + roundOffset + 'px,0)';
        self._$el.css('transform', position);
    }

    /**
     * Attach new focus
     * @private
     */
    Parallax.prototype._attach = function () {
        var $el = $(this),
            options = $el.data('parallax');

        new Parallax($el, options);
    };

    /**
     * Attach listeners to document
     */
    $(function () {
        /**
         * Travel through the DOM for data-focus attributes
         */
        //$('[data-parallax]').each(Parallax.prototype._attach);

        /**
         * Setup a jQuery chainable plugin for attaching to injected elements after page load
         * @type {*}
         */

        $.fn.jqParallax = function () {
            $(this).each(Parallax.prototype._attach);
        };
    });

})(jQuery, window);

